import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class ReportingAction extends BaseAction {
    constructor() {
        super();
    }

    public InitiateSingleSignOn(): void {
        var requestData = {

        };

        return this.Execute(ServerOperations.Server.Myle_Reporting_Sisense_SSO, requestData);
    }
}

export { ReportingAction };
